import { oembed as loomOembed, validate } from '@loomhq/loom-embed'
import ReactPlayer from 'react-player'
import { EMBEDDED_VIDEO_URL_MAX_LENGTH, NOEMBED_BASE_URL } from 'shared/constants'
import type { OEmbedInterface } from 'modules/attachments/types/attachment-types'
import { baseFetcher } from 'modules/comments/api/http-client'
import type {
  EmbeddedImageAttachment,
  EmbeddedVideoAttachment,
  GifAttachment,
  ImageUploadAttachment,
  PostAttachmentType,
  VideoUploadAttachment,
} from 'modules/community/types/post-attachment'
import { AttachmentTypeEnum } from 'modules/community/types/post-attachment'

export const isEmbeddedVideoUrlTooLong = (url: string): boolean =>
  url.length > EMBEDDED_VIDEO_URL_MAX_LENGTH

export const isValidEmbeddedVideoUrl = (url: string): boolean =>
  validate.isLoomUrl(url) || ReactPlayer.canPlay(url)

export const hasEmbeddedVideoAttachmentUrlTooLong = (
  attachments: PostAttachmentType[] = [],
): boolean =>
  attachments.some(
    attachment =>
      attachment.type === AttachmentTypeEnum.EmbeddedVideo &&
      !!attachment.url &&
      isEmbeddedVideoUrlTooLong(attachment.url),
  )

export const fetchOembed = async (url: string): Promise<OEmbedInterface | undefined> => {
  const isLoomUrl = validate.isLoomUrl(url)
  const encodedUrl = encodeURIComponent(url)

  if (isLoomUrl) {
    return loomOembed(url)
  }

  return baseFetcher<OEmbedInterface>(`${NOEMBED_BASE_URL}?url=${encodedUrl}`)
}

export const filterNotGalleryAttachments = (
  attachments: PostAttachmentType[],
): (
  | EmbeddedImageAttachment
  | EmbeddedVideoAttachment
  | GifAttachment
  | ImageUploadAttachment
  | VideoUploadAttachment
)[] => {
  return attachments.filter(attachment => attachment.type !== AttachmentTypeEnum.Audio)
}
